import React from "react";
import "./Preloader.css";
const Preloader = () => {
  return (
    <div id="loader-content">
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Preloader;
